export const GET_FOLLOW_UP_EXAM = "exams/GET_FOLLOW_UP_EXAM";
export const GET_FOLLOW_UP_EXAM_SUCCESS = "exams/GET_FOLLOW_UP_EXAM_SUCCESS";

export const RESET_FOLLOW_UP_EXAM = "exams/RESET_FOLLOW_UP_EXAM";

export const SAVE_REEXAM_ID = "exams/SAVE_REEXAM_ID";

export const CHECK_FOLLOW_UP_EXAM = "CHECK_FOLLOW_UP_EXAM";
export const CHECK_FOLLOW_UP_EXAM_SUCCESS = "CHECK_FOLLOW_UP_EXAM_SUCCESS";

export const RESET_STATUS_CHECKING = "RESET_STATUS_CHECKING";
export const CLEAR_LIST_FOLLOW_UP_EXAM = "CLEAR_LIST_FOLLOW_UP_EXAM";
